export const regexConstants = {
  auditMessage: /^[ -~]{10,1024}$/,
  // \u00C0 to \u02AF are the latin letters with accents Unicode such as ü
  name: /^[ -~\u00C0-\u02AF]{2,150}$/u,
  streetAddress: /^[ -~\u00C0-\u02AF\\n]{5,256}$/u,
  locality: /^[ -~\u00C0-\u02AF]{3,256}$/u,
  postalCode: /^[0-9-]{3,10}$/u,
};
